import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, Mail } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

// Resumen semanal: arrives every Monday 8:00 (Chile); this sends a preview now
export const WeeklyDigestButton = () => {
  const { api } = useAuth();
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const r = await api.post('/doctrine/weekly/send-me');
      if (r.data.sent) toast.success(`Te envié el resumen: ${r.data.apoyan} fallo(s) a favor y ${r.data.contradicen} en contra esta semana`);
      else toast.error('No se pudo enviar el correo');
    } catch { toast.error('No se pudo enviar el correo'); } finally { setBusy(false); }
  };
  return (
    <button data-testid="weekly-digest-send-btn" disabled={busy} onClick={send} title="El resumen llega cada lunes a las 8:00" className="flex items-center gap-1 rounded-full border border-slate-600 px-3 py-1 text-xs text-slate-200 hover:text-white disabled:opacity-60">
      {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Mail className="h-3 w-3" />}Resumen semanal (lunes 8:00) · enviármelo ahora
    </button>
  );
};
